import React, { useState } from 'react';

import { WrappedControlProps } from 'app/components/Controls/WrappedControlProps';
import { UtilService } from 'app/services/util.service';
import { containsNonNumeric } from 'app/shared/helpers/containeNonNumeric';

export function useMileageControl({
  input,
  meta: { touched, valid },
  onClick,
  onControlBlur,
  onValueChange,
}: WrappedControlProps) {
  const [focused, setFocused] = useState(false);
  const onFocus = () => setFocused(true);
  const error = touched && !valid;
  const isValueCheckVisible = !focused && UtilService.hasValue(input.value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = event.target;

    if (containsNonNumeric(value) || value.length > 3) {
      return;
    }

    if (value !== '') value = parseInt(value, 10).toFixed();

    input.onChange(value);

    if (onValueChange) {
      onValueChange(value, false, false);
    }
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const intValue = parseInt(value, 10);
    const normalizedValue = Number.isNaN(intValue) ? value : intValue.toFixed();

    setFocused(false);

    if (onControlBlur) {
      onControlBlur();
    }

    input.onBlur(normalizedValue);
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return {
    error,
    focused,
    handleBlur,
    handleChange,
    handleClick,
    isValueCheckVisible,
    onFocus,
  };
}
